var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "torir-spectrogram-controller" }, [
    _c("div", { staticClass: "--basic" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.zoom,
            expression: "zoom"
          }
        ],
        attrs: { type: "range", min: "-1", max: "1", step: "0.01" },
        domProps: { value: _vm.zoom },
        on: {
          __r: function($event) {
            _vm.zoom = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          on: {
            click: function($event) {
              _vm.detailsVisible = !_vm.detailsVisible
            }
          }
        },
        [_vm._v("\n\t\t\t設定\n\t\t")]
      )
    ]),
    _vm._v(" "),
    _vm.detailsVisible
      ? _c(
          "div",
          { staticClass: "--details" },
          [
            _c("FormGroup", { attrs: { label: "値域", fit: true } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.decibelMin,
                    expression: "decibelMin"
                  }
                ],
                attrs: { type: "number", size: "1", min: "-120", max: "100" },
                domProps: { value: _vm.decibelMin },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.decibelMin = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "--dash-range" }, [_vm._v("–")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.decibelMax,
                    expression: "decibelMax"
                  }
                ],
                attrs: { type: "number", size: "1", min: "-100", max: "120" },
                domProps: { value: _vm.decibelMax },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.decibelMax = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "unit" }, [_vm._v("dB")])
            ]),
            _vm._v(" "),
            _c("FormGroup", { attrs: { label: "ブースト", fit: true } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.decibelBoost,
                    expression: "decibelBoost"
                  }
                ],
                attrs: { type: "number", size: "1", min: "-120", max: "120" },
                domProps: { value: _vm.decibelBoost },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.decibelBoost = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "--unit" }, [_vm._v("dB / ")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ratioBoost,
                    expression: "ratioBoost"
                  }
                ],
                attrs: { type: "number", size: "1", min: "1", max: "10" },
                domProps: { value: _vm.ratioBoost },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.ratioBoost = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "--unit" }, [_vm._v(" ×")])
            ]),
            _vm._v(" "),
            _c("FormGroup", { attrs: { label: "クリップ", fit: true } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.decibelClip,
                    expression: "decibelClip"
                  }
                ],
                attrs: { type: "number", size: "1", min: "-120", max: "120" },
                domProps: { value: _vm.decibelClip },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.decibelClip = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "--unit" }, [_vm._v("dB / ")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.ratioClip,
                    expression: "ratioClip"
                  }
                ],
                attrs: { type: "number", size: "1", min: "1", max: "10" },
                domProps: { value: _vm.ratioClip },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.ratioClip = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "--unit" }, [_vm._v(" ×")])
            ]),
            _vm._v(" "),
            _c("FormGroup", { attrs: { label: "表示高さ", fit: true } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.height,
                    expression: "height"
                  }
                ],
                attrs: { type: "number", size: "1", min: "60", max: "1000" },
                domProps: { value: _vm.height },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.height = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "--unit" }, [_vm._v("px")]),
              _vm._v(" "),
              _c("span", { staticClass: "--space" })
            ]),
            _vm._v(" "),
            _c("FormGroup", { attrs: { label: "表示周波数", fit: true } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.freqMin,
                    expression: "freqMin"
                  }
                ],
                attrs: {
                  type: "number",
                  size: "1",
                  min: "0",
                  max: _vm.nyquist
                },
                domProps: { value: _vm.freqMin },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.freqMin = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "--dash-range" }, [_vm._v("–")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.freqMax,
                    expression: "freqMax"
                  }
                ],
                attrs: {
                  type: "number",
                  size: "1",
                  min: "0",
                  max: _vm.nyquist
                },
                domProps: { value: _vm.freqMax },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.freqMax = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "--unit" }, [_vm._v("Hz")])
            ]),
            _vm._v(" "),
            _c("FormGroup", { attrs: { label: "周波数解像度" } }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.fftsDegree,
                    expression: "fftsDegree"
                  }
                ],
                attrs: { type: "range", min: "6", max: "14", step: "1" },
                domProps: { value: _vm.fftsDegree },
                on: {
                  __r: function($event) {
                    _vm.fftsDegree = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "--note" }, [
                _vm._v(
                  "\n\t\t\t\tFFT samples = " +
                    _vm._s(_vm.fftSamples) +
                    "\n\t\t\t"
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "--action" }, [
              _c(
                "button",
                { attrs: { type: "button" }, on: { click: _vm.apply } },
                [_vm._v("\n\t\t\t\t適用\n\t\t\t")]
              )
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }